<template>
  <div class="device-base">
    <div class="title" v-if="!!device">
      <span>{{device.deviceCode}}</span>
      <span>{{device.deviceName}}</span>
      <span v-if="status && status.online" class="color-success">
        <i class="fa fa-chain"></i>
        在线
      </span>
      <span v-else class="color-error" >
        <i class="fa fa-chain-broken"></i>
        离线
      </span>
    </div>
    <div class="address" v-if="!!device">
      <span>地址：{{device.address}}</span>
      <span>
        <el-button type="text" @click="mapVisible=true"><i class="fa fa-location-arrow"></i></el-button>
      </span>
    </div>

    <div class="blocks" v-if="device && device.deviceType !== '3'">
      <div class="block-wrapper">
        <div class="block">
          <el-image :src="require('../../assets/fan.png')" class="rotate" v-if="status && status.fanState==='1'"></el-image>
          <el-image :src="require('../../assets/fan2.png')" v-else></el-image>
          <div class="label">新风</div>
        </div>
      </div>
      <div class="block-wrapper">
        <div class="block">
          <el-image :src="require('../../assets/fan.png')" class="rotate" v-if="status && status.acState==='1'"></el-image>
          <el-image :src="require('../../assets/fan2.png')" v-else></el-image>
          <div class="label">空调</div>
        </div>
      </div>
      <div class="block-wrapper">
        <div class="block">
          <div class="color-success icon-font" v-if="status && status.online">
            {{status.inTemp}}℃ {{status.outTemp}}℃
          </div>
          <div class="color-gray icon-font" v-else>
            /
          </div>
          <div class="label">内外温度</div>
        </div>
      </div>
      <div class="block-wrapper">
        <div class="block">
          <div class="color-success icon-font" v-if="status && status.online">
            {{status.inWet}}% {{status.outWet}}%
          </div>
          <div class="color-gray icon-font" v-else>
            /
          </div>
          <div class="label">内外湿度</div>
        </div>
      </div>
      <div class="block-wrapper">
        <div class="block">
          <div class="color-success icon-font" v-if="status && status.online">
            {{status.kwh || '无'}}
          </div>
          <div class="color-gray icon-font" v-else>
            /
          </div>
          <div class="label">电表</div>
        </div>
      </div>
      <div class="block-wrapper">
        <div class="block">
          <div class="color-success icon-font" v-if="status && status.online">
            {{status.pm}}μg/m³
          </div>
          <div class="color-gray icon-font" v-else>
            /
          </div>
          <div class="label">PM2.5</div>
        </div>
      </div>
      <div class="block-wrapper">
        <div class="block">
          <div class="color-success icon-font" v-if="status && status.online">
            {{Math.round(status.clothLeftTime/24)}}天
          </div>
          <div class="color-gray icon-font" v-else>
            /
          </div>
          <div class="label">过滤系统</div>
        </div>
      </div>
    </div>

    <div class="blocks" v-if="device && device.deviceType === '3' && status && status.online">
      <div class="block-wrapper">
        <div class="block">
          <el-image :src="require('../../assets/fan.png')" class="rotate" v-if="status.fanState === '1'"></el-image>
          <el-image :src="require('../../assets/fan2.png')" v-else></el-image>
          <div class="label">新风</div>
        </div>
      </div>
      <div class="block-wrapper">
        <div class="block">
          <el-image :src="require('../../assets/fan.png')" class="rotate" v-if="status.acState === '1'"></el-image>
          <el-image :src="require('../../assets/fan2.png')" v-else></el-image>
          <div class="label">空调</div>
        </div>
      </div>
      <div class="block-wrapper">
        <div class="block">
          <div class="color-success icon-font">
            {{status.inTemperature || '-'}}℃
          </div>
          <div class="label">室内温度</div>
        </div>
      </div>
      <div class="block-wrapper">
        <div class="block">
          <div class="color-success icon-font">
            {{status.outTemperature || '-'}}℃
          </div>
          <div class="label">室外温度</div>
        </div>
      </div>
      <div class="block-wrapper">
        <div class="block">
          <div class="color-success icon-font">
            {{status.inHumidity || '-'}}%
          </div>
          <div class="label">室内湿度</div>
        </div>
      </div>
      <div class="block-wrapper">
        <div class="block">
          <div class="color-success icon-font">
            {{status.outHumidity || '-'}}%
          </div>
          <div class="label">室外湿度</div>
        </div>
      </div>
      <div class="block-wrapper">
        <div class="block">
          <div class="color-success icon-font">
            {{status.backWindTemp || '-'}}℃
          </div>
          <div class="label">新风混风口温度</div>
        </div>
      </div>
      <div class="block-wrapper">
        <div class="block">
          <div class="color-success icon-font">
            {{status.outWindTemp || '-'}}℃
          </div>
          <div class="label">新风出风口温度</div>
        </div>
      </div>
      <div class="block-wrapper">
        <div class="block">
          <div class="color-success icon-font">
            {{status.mixedValveAngle ? status.mixedValveAngle.toFixed(1) : '-'}}°
          </div>
          <div class="label">新风混风风阀角度</div>
        </div>
      </div>
      <div class="block-wrapper">
        <div class="block">
          <div class="color-success icon-font">
            {{status.inValveAngle ? status.inValveAngle.toFixed(1) : '-'}}°
          </div>
          <div class="label">新风进风风阀角度</div>
        </div>
      </div>
      <div class="block-wrapper">
        <div class="block">
          <div class="color-success icon-font">
            {{status.backValve? '开' : '关'}}
          </div>
          <div class="label">新风止回阀状态</div>
        </div>
      </div>
      <div class="block-wrapper">
        <div class="block">
          <div class="color-success icon-font">
            {{status.outValve ? '开' : '关'}}
          </div>
          <div class="label">新风一级排风阀状态</div>
        </div>
      </div>
      <div class="block-wrapper">
        <div class="block">
          <div class="color-success icon-font">
            {{status.kwh || '-'}}
          </div>
          <div class="label">电表</div>
        </div>
      </div>
    </div>

    <div class="blocks" v-if="device && status && status.online">
      <div class="block-wrapper" v-if="status.errInFan1">
        <div class="block error">
          <div class="label">
            <i class="fa fa-exclamation-triangle" />
            1#进风机异常
          </div>
        </div>
      </div>
      <div class="block-wrapper" v-if="status.errInFan2">
        <div class="block error">
          <div class="label">
            <i class="fa fa-exclamation-triangle" />
            2#进风机异常
          </div>
        </div>
      </div>
      <div class="block-wrapper" v-if="status.errOutFan1">
        <div class="block error">
          <div class="label">
            <i class="fa fa-exclamation-triangle" />
            1#排风机异常
          </div>
        </div>
      </div>
      <div class="block-wrapper" v-if="status.errOutFan2">
        <div class="block error">
          <div class="label">
            <i class="fa fa-exclamation-triangle" />
            2#排风机异常
          </div>
        </div>
      </div>
      <div class="block-wrapper" v-if="status.errAc">
        <div class="block error">
          <div class="label">
            <i class="fa fa-exclamation-triangle" />
            空调异常
          </div>
        </div>
      </div>
      <div class="block-wrapper" v-if="status.errFire">
        <div class="block error">
          <div class="label">
            <i class="fa fa-exclamation-triangle" />
            消防急停
          </div>
        </div>
      </div>
      <div class="block-wrapper" v-if="status.errOutTemp">
        <div class="block error">
          <div class="label">
            <i class="fa fa-exclamation-triangle" />
            室外温度传感器离线故障
          </div>
        </div>
      </div>
      <div class="block-wrapper" v-if="status.errInTemp">
        <div class="block error">
          <div class="label">
            <i class="fa fa-exclamation-triangle" />
            室内温度传感器离线故障
          </div>
        </div>
      </div>
      <div class="block-wrapper" v-if="status.errSendWindTemp">
        <div class="block error">
          <div class="label">
            <i class="fa fa-exclamation-triangle" />
            送风温度传感器离线故障
          </div>
        </div>
      </div>
      <div class="block-wrapper" v-if="status.errBackWindTemp">
        <div class="block error">
          <div class="label">
            <i class="fa fa-exclamation-triangle" />
            回风温度传感器离线故障
          </div>
        </div>
      </div>
      <div class="block-wrapper" v-if="status.errNetPressure">
        <div class="block error">
          <div class="label">
            <i class="fa fa-exclamation-triangle" />
            滤网压差传感器离线故障
          </div>
        </div>
      </div>
      <div class="block-wrapper" v-if="status.errKwh">
        <div class="block error">
          <div class="label">
            <i class="fa fa-exclamation-triangle" />
            电表离线故障
          </div>
        </div>
      </div>
      <div class="block-wrapper" v-if="status.errorSensor">
        <div class="block error">
          <div class="label">
            <i class="fa fa-exclamation-triangle" />
            传感器异常
          </div>
        </div>
      </div>
      <div class="block-wrapper" v-if="status.highTemp">
        <div class="block error">
          <div class="label">
            <i class="fa fa-exclamation-triangle" />
            高温告警
          </div>
        </div>
      </div>
    </div>

    <map-choose-dialog title="位置查看" :visible.sync="mapVisible"
                       v-if="mapVisible" width="90vw"
                       :lng="device.lng"
                       :lat="device.lat"
                       @close="mapVisible = false"></map-choose-dialog>

  </div>
</template>

<script>

import BaseVue from "@/components/base/BaseVue";
import MapChooseDialog from "@/components/base/MapChooseDialog";

export default {
  extends: BaseVue,
  components: {MapChooseDialog},

  props: {
    deviceCode : {
      required: true
    }
  },

  data() {
    return {
      device: null,
      it: null,
      status: null,
      mapVisible: false
    }
  },
  created() {
    this.loading = true;
    this.postForm("/device/getDevice", {
      deviceCode: this.deviceCode
    }, true).then(dr => {
      this.device = dr.bean || {};
    }).finally(()=>{
      this.loading = false;
    });

    this.it = setInterval(()=>{
      this.postForm("/device-status/currentStatus", {
        deviceCode: this.deviceCode
      }).then(dr => {
        this.status = dr.bean;
      })
    }, 2000);
  },
  beforeDestroy() {
    if(this.it) {
      clearInterval(this.it)
    }
  },
  methods: {
  }
}
</script>

<style lang="scss" scoped>
@import "../../css/variables";
.device-base{
  margin-bottom: 20px;
  .title {
    font-size: 16px;
    font-weight: bold;
    line-height: 24px;
    i{
      font-size: 20px;
    }
    span{
      margin-right: 20px;
    }
  }
  .address{
    span+span{
      margin-left: 20px;
    }
    i{
      font-size: 20px;
    }
  }
  .blocks {
    display: flex;
    justify-content: stretch;
    flex-wrap: wrap;
    div.block-wrapper {
      padding: 10px;
      width: 14%;
      div.block {
        border: 1px solid $color-border-primary;
        border-radius: 0;
        text-align: center;
        padding: 10px;

        .el-image {
          width: 32px;
          height: 32px;
        }

        .icon-font {
          white-space: nowrap;
          height: 34px;
          line-height: 34px;
          font-size: 18px;
        }

        .rotate {
          -webkit-animation: anim-rotate .8s linear infinite;
          animation: anim-rotate .8s linear infinite;
        }

        .fadein {
          -webkit-animation: anim-fadein .8s linear infinite;
          animation: anim-fadein .8s linear infinite;
        }

        .label {
          padding-top: 10px;
        }
      }
      div.block.error{
        height: 60px;
        background-color: $color-error;
        color: #fff3f3;
      }
    }
  }
}

@-webkit-keyframes anim-rotate{
  from{
    -webkit-transform:rotate(0);
  }
  to{
    -webkit-transform:rotate(360deg)
  }
}
@keyframes anim-rotate{
  from{
    transform:rotate(0)
  }
  to{
    transform:rotate(360deg)
  }
}
@-webkit-keyframes anim-fadein{
  0%{opacity:0}
  50%{opacity:1}
  100%{opacity:0}
}
@keyframes anim-fadein{
  0%{opacity:0}
  50%{opacity:1}
  100%{opacity:0}
}
</style>
